<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">BULK BILL UPLOAD</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item"><a @click="gotTo('unpaid-bills')">Bills</a></li>
                      <li class="breadcrumb-item active">BULK UPLOAD</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Upload Section -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-cloud-upload-outline me-2"></i>
                      Bulk Bill Upload
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- Upload Form -->
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label class="form-label">Revenue Stream <span class="text-danger">*</span></label>
                          <select v-model="selectedStream" class="form-select">
                            <option value="">Select Revenue Stream</option>
                            <option v-for="stream in streams" :key="stream.id" :value="stream">
                              {{ stream.name }}
                            </option>
                          </select>
                        </div>

                        <div class="mb-3">
                          <label class="form-label">Billing Period <span class="text-danger">*</span></label>
                          <div class="row">
                            <div class="col-6">
                              <input v-model="billingPeriod.from" type="date" class="form-control" placeholder="From">
                            </div>
                            <div class="col-6">
                              <input v-model="billingPeriod.to" type="date" class="form-control" placeholder="To">
                            </div>
                          </div>
                        </div>

                        <div class="mb-3">
                          <label class="form-label">Due Date <span class="text-danger">*</span></label>
                          <input v-model="dueDate" type="date" class="form-control">
                        </div>

                        <div class="mb-3">
                          <label class="form-label">Upload File <span class="text-danger">*</span></label>
                          <input @change="handleFileUpload" type="file" class="form-control" accept=".csv,.xlsx,.xls">
                          <small class="text-muted">Supported formats: CSV, Excel (.xlsx, .xls)</small>
                        </div>

                        <div class="d-flex gap-2">
                          <button @click="validateUpload" :disabled="!canValidate || validating"
                                  class="btn btn-outline-primary">
                            <i v-if="!validating" class="mdi mdi-check-circle-outline me-1"></i>
                            <div v-else class="spinner-border spinner-border-sm me-1" role="status"></div>
                            Validate Data
                          </button>

                          <button @click="processUpload" :disabled="!canProcess || processing"
                                  class="btn btn-success">
                            <i v-if="!processing" class="mdi mdi-upload me-1"></i>
                            <div v-else class="spinner-border spinner-border-sm me-1" role="status"></div>
                            Process Upload
                          </button>
                        </div>
                      </div>

                      <!-- Template Download -->
                      <div class="col-md-6">
                        <div class="border rounded p-4 bg-light">
                          <h5 class="mb-3">
                            <i class="mdi mdi-download-outline me-2"></i>
                            Download Templates
                          </h5>
                          <p class="text-muted mb-3">
                            Download the appropriate template for your revenue stream to ensure proper data formatting.
                          </p>

                          <div class="d-grid gap-2">
                            <button @click="downloadTemplate('SBP')" class="btn btn-outline-secondary">
                              <i class="mdi mdi-file-excel-outline me-2"></i>
                              SBP Template
                            </button>
                            <button @click="downloadTemplate('LIQUOR')" class="btn btn-outline-secondary">
                              <i class="mdi mdi-file-excel-outline me-2"></i>
                              Liquor License Template
                            </button>
                            <button @click="downloadTemplate('LAND_RATES')" class="btn btn-outline-secondary">
                              <i class="mdi mdi-file-excel-outline me-2"></i>
                              Land Rates Template
                            </button>
                            <button @click="downloadTemplate('GENERAL')" class="btn btn-outline-secondary">
                              <i class="mdi mdi-file-excel-outline me-2"></i>
                              General Template
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Penalty Management -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-warning text-dark">
                    <h4 class="card-title mb-0">
                      <i class="mdi mdi-alert-circle-outline me-2"></i>
                      Penalty Management
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <div class="form-check form-switch">
                            <input v-model="penaltySettings.enabled" class="form-check-input" type="checkbox" id="enablePenalty">
                            <label class="form-check-label fw-bold" for="enablePenalty">
                              Enable Automatic Penalties for Overdue Bills
                            </label>
                          </div>
                        </div>

                        <div v-if="penaltySettings.enabled">
                          <div class="mb-3">
                            <label class="form-label">Penalty Type</label>
                            <select v-model="penaltySettings.type" class="form-select">
                              <option value="PERCENTAGE">Percentage (%)</option>
                              <option value="FIXED">Fixed Amount (KES)</option>
                            </select>
                          </div>

                          <div class="mb-3">
                            <label class="form-label">
                              {{ penaltySettings.type === 'PERCENTAGE' ? 'Penalty Rate (%)' : 'Penalty Amount (KES)' }}
                            </label>
                            <input v-model="penaltySettings.value" type="number" step="0.01" class="form-control">
                          </div>

                          <div class="mb-3">
                            <label class="form-label">Grace Period (Days)</label>
                            <input v-model="penaltySettings.gracePeriod" type="number" class="form-control">
                            <small class="text-muted">Number of days after due date before penalty applies</small>
                          </div>

                          <div class="mb-3">
                            <label class="form-label">Penalty Application</label>
                            <select v-model="penaltySettings.application" class="form-select">
                              <option value="ONCE">Apply Once</option>
                              <option value="MONTHLY">Apply Monthly</option>
                              <option value="DAILY">Apply Daily</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <div class="border rounded p-3 bg-light">
                          <h6 class="mb-3">Penalty Configuration Preview</h6>
                          <div v-if="penaltySettings.enabled">
                            <p><strong>Type:</strong> {{ penaltySettings.type === 'PERCENTAGE' ? 'Percentage' : 'Fixed Amount' }}</p>
                            <p><strong>Rate/Amount:</strong>
                              {{ penaltySettings.type === 'PERCENTAGE' ? penaltySettings.value + '%' : 'KES ' + formatPrice(penaltySettings.value) }}
                            </p>
                            <p><strong>Grace Period:</strong> {{ penaltySettings.gracePeriod }} days</p>
                            <p><strong>Application:</strong> {{ penaltySettings.application.toLowerCase() }}</p>

                            <div class="alert alert-warning alert-sm mt-3">
                              <small>
                                <i class="mdi mdi-information me-1"></i>
                                Penalties will be automatically applied to bills that exceed the due date by more than the grace period.
                              </small>
                            </div>
                          </div>
                          <div v-else>
                            <p class="text-muted">Penalty system is disabled. Bills will not attract additional charges when overdue.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Upload Progress -->
            <div v-if="uploadProgress.show" class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title mb-0">Upload Progress</h4>
                  </div>
                  <div class="card-body">
                    <div class="mb-3">
                      <div class="d-flex justify-content-between mb-1">
                        <span>Processing Records</span>
                        <span>{{ uploadProgress.processed }} / {{ uploadProgress.total }}</span>
                      </div>
                      <div class="progress">
                        <div class="progress-bar" :style="{ width: uploadProgress.percentage + '%' }"></div>
                      </div>
                    </div>

                    <div class="row text-center">
                      <div class="col-md-3">
                        <div class="border rounded p-3">
                          <h5 class="text-success mb-0">{{ uploadProgress.success }}</h5>
                          <small class="text-muted">Successful</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3">
                          <h5 class="text-danger mb-0">{{ uploadProgress.failed }}</h5>
                          <small class="text-muted">Failed</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3">
                          <h5 class="text-warning mb-0">{{ uploadProgress.duplicates }}</h5>
                          <small class="text-muted">Duplicates</small>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="border rounded p-3">
                          <h5 class="text-info mb-0">{{ uploadProgress.withPenalties }}</h5>
                          <small class="text-muted">With Penalties</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Validation Results -->
            <div v-if="validationResults.length > 0" class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-info text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-clipboard-list-outline me-2"></i>
                      Validation Results
                    </h4>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Row</th>
                          <th>Customer</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Issues</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(result, index) in validationResults" :key="index">
                          <td>{{ result.row }}</td>
                          <td>{{ result.customerName }}</td>
                          <td>{{ formatPrice(result.amount) }}</td>
                          <td>
                            <span class="badge" :class="result.valid ? 'bg-success' : 'bg-danger'">
                              {{ result.valid ? 'Valid' : 'Invalid' }}
                            </span>
                          </td>
                          <td>
                            <ul v-if="result.issues.length > 0" class="list-unstyled mb-0">
                              <li v-for="issue in result.issues" :key="issue" class="text-danger">
                                <small>• {{ issue }}</small>
                              </li>
                            </ul>
                            <span v-else class="text-success">No issues</span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Recent Uploads -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Recent Bulk Uploads</h4>
                      <button @click="refreshHistory" class="btn btn-outline-primary btn-sm">
                        <i class="mdi mdi-refresh me-1"></i>
                        Refresh
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th>Date</th>
                          <th>Revenue Stream</th>
                          <th>Total Records</th>
                          <th>Successful</th>
                          <th>Failed</th>
                          <th>Amount</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(upload, index) in uploadHistory" :key="index">
                          <td>{{ upload.dateCreated }}</td>
                          <td>{{ upload.revenueStream }}</td>
                          <td>{{ upload.totalRecords }}</td>
                          <td>
                            <span class="text-success fw-bold">{{ upload.successful }}</span>
                          </td>
                          <td>
                            <span class="text-danger fw-bold">{{ upload.failed }}</span>
                          </td>
                          <td>{{ formatPrice(upload.totalAmount) }}</td>
                          <td>
                            <span class="badge" :class="upload.status === 'COMPLETED' ? 'bg-success' : upload.status === 'PROCESSING' ? 'bg-warning' : 'bg-danger'">
                              {{ upload.status }}
                            </span>
                          </td>
                          <td>
                            <div class="d-flex gap-1">
                              <button @click="viewUploadDetails(upload)"
                                      class="btn btn-outline-primary btn-sm">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button @click="downloadUploadReport(upload)"
                                      class="btn btn-outline-success btn-sm">
                                <i class="mdi mdi-download"></i>
                              </button>
                              <button v-if="upload.status === 'FAILED'"
                                      @click="retryUpload(upload)"
                                      class="btn btn-outline-warning btn-sm">
                                <i class="mdi mdi-replay"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- No Results -->
                      <div v-if="uploadHistory.length < 1" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Upload History</h4>
                        <p>No bulk uploads have been performed yet. Start by uploading your first batch of bills.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Upload Details Modal -->
        <UploadDetailsModal
            :uploadDetails="selectedUploadDetails"
            @retry-failed-records="retryFailedRecords"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import UploadDetailsModal from "@/components/invoices/modals/UploadDetailsModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "BulkBillUpload",
  components: {
    NavigationBar,
    UploadDetailsModal
  },
  data() {
    return {
      // Form data
      selectedStream: '',
      billingPeriod: {
        from: '',
        to: ''
      },
      dueDate: '',
      uploadFile: null,

      // Penalty settings
      penaltySettings: {
        enabled: false,
        type: 'PERCENTAGE', // PERCENTAGE or FIXED
        value: 5, // percentage or amount
        gracePeriod: 7, // days
        application: 'ONCE' // ONCE, MONTHLY, DAILY
      },

      // Upload states
      validating: false,
      processing: false,
      validationResults: [],

      // Upload progress
      uploadProgress: {
        show: false,
        processed: 0,
        total: 0,
        percentage: 0,
        success: 0,
        failed: 0,
        duplicates: 0,
        withPenalties: 0
      },

      // Data
      streams: [
        { id: 1, name: 'Single Business Permit (SBP)', incomeTypePrefix: 'SBP' },
        { id: 2, name: 'Liquor License', incomeTypePrefix: 'LIQ' },
        { id: 3, name: 'Land Rates', incomeTypePrefix: 'LR' },
        { id: 4, name: 'Market Fees', incomeTypePrefix: 'MF' },
        { id: 5, name: 'Parking Fees', incomeTypePrefix: 'PF' },
        { id: 6, name: 'Building Plan Approval', incomeTypePrefix: 'BPA' }
      ],

      uploadHistory: [
        {
          id: 1,
          dateCreated: '2025-01-15 10:30:00',
          revenueStream: 'Single Business Permit (SBP)',
          totalRecords: 150,
          successful: 145,
          failed: 5,
          totalAmount: 2450000,
          status: 'COMPLETED',
          fileName: 'sbp_january_2025.xlsx'
        },
        {
          id: 2,
          dateCreated: '2025-01-14 14:20:00',
          revenueStream: 'Liquor License',
          totalRecords: 89,
          successful: 89,
          failed: 0,
          totalAmount: 1780000,
          status: 'COMPLETED',
          fileName: 'liquor_licenses_q1.csv'
        },
        {
          id: 3,
          dateCreated: '2025-01-13 09:15:00',
          revenueStream: 'Land Rates',
          totalRecords: 500,
          successful: 485,
          failed: 15,
          totalAmount: 12500000,
          status: 'COMPLETED',
          fileName: 'land_rates_2025.xlsx'
        },
        {
          id: 4,
          dateCreated: '2025-01-12 16:45:00',
          revenueStream: 'Market Fees',
          totalRecords: 75,
          successful: 0,
          failed: 75,
          totalAmount: 0,
          status: 'FAILED',
          fileName: 'market_fees_january.csv'
        }
      ],

      selectedUploadDetails: {},

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  computed: {
    canValidate() {
      return this.selectedStream && this.billingPeriod.from && this.billingPeriod.to &&
          this.dueDate && this.uploadFile;
    },

    canProcess() {
      return this.canValidate && this.validationResults.length > 0 &&
          this.validationResults.some(r => r.valid);
    }
  },
  mounted() {
    this.billingPeriod.from = moment().startOf('month').format('YYYY-MM-DD');
    this.billingPeriod.to = moment().endOf('month').format('YYYY-MM-DD');
    this.dueDate = moment().add(30, 'days').format('YYYY-MM-DD');

    this.menuAccess();
  },
  methods: {
    getRight,

    formatPrice(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },

    gotTo(route) {
      router.push(route);
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const allowedTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/csv'
        ];

        if (allowedTypes.includes(file.type)) {
          this.uploadFile = file;
          this.validationResults = []; // Clear previous validation
        } else {
          this.message = "Please upload a valid CSV or Excel file";
          this.alert.failed = true;
          event.target.value = '';
        }
      }
    },

    async validateUpload() {
      try {
        this.validating = true;
        this.validationResults = [];

        // Simulate API call delay
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Generate mock validation results
        const mockData = this.generateMockValidationData();
        this.validationResults = mockData;

        const validCount = mockData.filter(r => r.valid).length;
        const invalidCount = mockData.filter(r => !r.valid).length;

        this.message = `Validation completed: ${validCount} valid records, ${invalidCount} invalid records`;
        this.alert.info = true;

        this.validating = false;
      } catch (e) {
        this.validating = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    generateMockValidationData() {
      const customers = [
        'John Doe Enterprises', 'Mary\'s Beauty Salon', 'Tech Solutions Ltd',
        'Green Valley Restaurant', 'City Hardware Store', 'Fashion Point Boutique',
        'Quick Mart Grocery', 'Elite Motors', 'Sunrise Bakery', 'Modern Pharmacy'
      ];

      const issues = [
        'Missing phone number',
        'Invalid email format',
        'Duplicate customer ID',
        'Amount below minimum threshold',
        'Invalid location code',
        'Missing required documents'
      ];

      const data = [];
      for (let i = 1; i <= 25; i++) {
        const isValid = Math.random() > 0.2; // 80% valid records
        const customerName = customers[Math.floor(Math.random() * customers.length)];
        const amount = Math.floor(Math.random() * 50000) + 5000;

        const record = {
          row: i,
          customerName: customerName,
          amount: amount,
          valid: isValid,
          issues: []
        };

        if (!isValid) {
          const numIssues = Math.floor(Math.random() * 3) + 1;
          const selectedIssues = [];
          for (let j = 0; j < numIssues; j++) {
            const issue = issues[Math.floor(Math.random() * issues.length)];
            if (!selectedIssues.includes(issue)) {
              selectedIssues.push(issue);
            }
          }
          record.issues = selectedIssues;
        }

        data.push(record);
      }

      return data;
    },

    async processUpload() {
      try {
        this.processing = true;
        this.uploadProgress.show = true;
        this.uploadProgress.processed = 0;
        this.uploadProgress.total = this.validationResults.filter(r => r.valid).length;
        this.uploadProgress.success = 0;
        this.uploadProgress.failed = 0;
        this.uploadProgress.duplicates = 0;
        this.uploadProgress.withPenalties = 0;

        // Simulate processing records
        for (let i = 0; i < this.uploadProgress.total; i++) {
          await new Promise(resolve => setTimeout(resolve, 100));

          this.uploadProgress.processed = i + 1;
          this.uploadProgress.percentage = Math.round((this.uploadProgress.processed / this.uploadProgress.total) * 100);

          // Simulate random outcomes
          const outcome = Math.random();
          if (outcome > 0.9) {
            this.uploadProgress.failed++;
          } else if (outcome > 0.85) {
            this.uploadProgress.duplicates++;
          } else {
            this.uploadProgress.success++;

            // Check if penalty should be applied
            if (this.penaltySettings.enabled && Math.random() > 0.7) {
              this.uploadProgress.withPenalties++;
            }
          }
        }

        // Add to upload history
        const newUpload = {
          id: this.uploadHistory.length + 1,
          dateCreated: moment().format('YYYY-MM-DD HH:mm:ss'),
          revenueStream: this.selectedStream.name,
          totalRecords: this.uploadProgress.total,
          successful: this.uploadProgress.success,
          failed: this.uploadProgress.failed,
          totalAmount: this.validationResults.reduce((sum, r) => r.valid ? sum + r.amount : sum, 0),
          status: 'COMPLETED',
          fileName: this.uploadFile.name
        };

        this.uploadHistory.unshift(newUpload);

        this.message = `Upload completed successfully! ${this.uploadProgress.success} bills created.`;
        this.alert.success = true;
        this.processing = false;

        // Reset form after successful upload
        setTimeout(() => {
          this.resetForm();
        }, 3000);

      } catch (e) {
        this.processing = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    resetForm() {
      this.selectedStream = '';
      this.uploadFile = null;
      this.validationResults = [];
      this.uploadProgress.show = false;
      document.querySelector('input[type="file"]').value = '';
    },

    downloadTemplate(type) {
      // Simulate template download
      const templates = {
        SBP: 'SBP_Upload_Template.xlsx',
        LIQUOR: 'Liquor_License_Template.xlsx',
        LAND_RATES: 'Land_Rates_Template.xlsx',
        GENERAL: 'General_Bill_Template.xlsx'
      };

      const fileName = templates[type];
      this.message = `Downloading ${fileName}...`;
      this.alert.info = true;

      // In real implementation, this would trigger actual file download
      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    refreshHistory() {
      this.message = "Upload history refreshed";
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    viewUploadDetails(upload) {
      this.selectedUploadDetails = upload;

      // Open modal
      const modalElement = document.getElementById('uploadDetailsModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    downloadUploadReport(upload) {
      this.message = `Downloading report for ${upload.fileName}...`;
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = '';
      }, 2000);
    },

    retryUpload(upload) {
      this.message = `Retrying upload for ${upload.fileName}...`;
      this.alert.info = true;

      // Update status to processing
      upload.status = 'PROCESSING';

      setTimeout(() => {
        upload.status = 'COMPLETED';
        upload.successful = upload.totalRecords;
        upload.failed = 0;

        this.alert.info = false;
        this.message = 'Upload retry completed successfully!';
        this.alert.success = true;
      }, 3000);
    },

    retryFailedRecords(uploadId) {
      this.message = 'Retrying failed records...';
      this.alert.info = true;

      setTimeout(() => {
        this.alert.info = false;
        this.message = 'Failed records processed successfully!';
        this.alert.success = true;
      }, 2000);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Bulk Bill Upload");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.form-label {
  font-weight: 600;
  font-size: 0.875rem;
}

.card-header.bg-primary h4 {
  color: white !important;
}

.progress {
  height: 8px;
}

.alert-sm {
  padding: 0.5rem;
  font-size: 0.875rem;
}

.border {
  border-color: #dee2e6 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
</style>